export default "__VITE_ASSET__BkiWQ1u0__"